import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { ICheckupTypeModel, ICheckupItemModel } from "@/model";

/**
 *  体检项目类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class CheckupService extends ServiceBase {

    /**
     * 新增/编辑体检项目
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async opertionItem(data: ICheckupItemModel): Promise<IHttpResponse> {
        let response;

        if(data.id)
        {
            response = await this.apis.editBaseItem({ data });
        }else
        {
            response = await this.apis.addBaseItem({ data });
        }
        
        return response;
    }

    /**
     * 删除体检项目
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteItem(id: number): Promise<IHttpResponse> {
        let response = await this.apis.delBaseItem({ urlPath: { id } });
        return response;
    }

    /**
     * 查询体检项目
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getBaseItemDetail(id: number | string): Promise<IHttpResponse> {
        let response = await this.apis.getBaseItemDetail({ urlPath: { id } });
        return response;
    }
    
    /**
     * 获取体检项目分页数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getItemPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getBaseItemPage({ data });
        return response;
    }
    
    /**
     * 添加体检类别
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addType(data: ICheckupTypeModel): Promise<IHttpResponse> {
        let response = await this.apis.addBaseItemType({ data });
        return response;
    }

    /**
     * 删除体检类别
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteType(id: number): Promise<IHttpResponse> {
        let response = await this.apis.delBaseItemType({ urlPath: { id } });
        return response;
    }

    /**
     * 修改体检类别
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async editType(data: ICheckupTypeModel): Promise<IHttpResponse> {
        let response = await this.apis.editBaseItemType({ data });
        return response;
    }

    /**
     * 获取体检类别分页数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getTypePage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getBaseItemTypePage({ data });
        return response;
    }

    /**
     * 获取体检类别列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getTypeList(reserveType: number): Promise<IHttpResponse> {
        let response = await this.apis.getBaseItemTypeList({
            params:{reserveType}
        });
        return response;
    }
    /**
     * 上传
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async baseItemUpFile(data: any): Promise<IHttpResponse> {
        let response = await this.apis.baseItemUpFile({
            data
        });
        return response;
    }
}